module.exports = __webpack_public_path__ + "img/img3-4.a284283d.png";